(function(angular) {
    angular.module('bizPartEngage').service('modules.speedquiz.service', speedquizService);

    speedquizService.$inject = ["$http", "$q"];

    function speedquizService($http, $q) {        

        this.GetSpeedquizInstancesForLoggedInUser = function() {
            return $http.get(siteRootPath + "api/speedquiz/GetSpeedquizInstancesForLoggedInUser");
        };

        this.GetHighscore = function(pluginInstanceId, max) {
            return $http.get(siteRootPath + "api/speedquiz/GetHighscore?" + $.param({id: pluginInstanceId, max:max}));
        };

        this.GetSpeedquizIdByUrlRewrite = function (urlRewrite) {
            return $http.get(siteRootPath + "api/speedquiz/GetSpeedquizIdByUrlRewrite?" + $.param({ urlRewrite: urlRewrite }));
        };

        this.GetSpeedquizInstance = function (quizId) {
            return $http.get(siteRootPath + "api/speedquiz/GetSpeedquizInstance?" + $.param(
                {
                    id: quizId,
                    assemblyName: 'BizPartEngage.Speedquiz.dll',
                    className: 'BizPartEngage.Speedquiz.Plugins.SpeedquizGeneralPlugin',
                    objectId: -1
                }
            ));
        };

        this.Answer = function (answer) {
            return $http.post(siteRootPath + "api/speedquiz/Answer", answer, { headers: { IgnoreLoader: true }});
        }

        this.Submit = function (score) {
            return $http.post(siteRootPath + "api/speedquiz/SubmitScore", score, { headers: { IgnoreLoader: true } });
        }

        this.HasGuiOverrides = function () {
            var defer = $q.defer();
            
            var v = getSessionStorage('SPEEDQUIZ_HAS_GUI_OVERRIDES');            
            if (v === undefined || v === null) {                
                $http.get(siteRootPath + "api/speedquiz/HasCustomerGuiOverrides").then(WSCallback);
            } else {                
                defer.resolve(v === 'true');                
            }

            return defer.promise;

            function WSCallback(response) {
                setSessionStorage('SPEEDQUIZ_HAS_GUI_OVERRIDES', response.data);                
                defer.resolve(response.data);
            }
        };
    }
})(window.angular);